var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aim") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aim",
    transform: "translate(-1.000000, -1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3125,11.109375 L19.4484375,11.109375 C19.0429688,7.678125 16.321875,4.95703125 12.890625,4.5515625 L12.890625,1.6875 C12.890625,1.584375 12.80625,1.5 12.703125,1.5 L11.296875,1.5 C11.19375,1.5 11.109375,1.584375 11.109375,1.6875 L11.109375,4.5515625 C7.678125,4.95703125 4.95703125,7.678125 4.5515625,11.109375 L1.6875,11.109375 C1.584375,11.109375 1.5,11.19375 1.5,11.296875 L1.5,12.703125 C1.5,12.80625 1.584375,12.890625 1.6875,12.890625 L4.5515625,12.890625 C4.95703125,16.321875 7.678125,19.0429688 11.109375,19.4484375 L11.109375,22.3125 C11.109375,22.415625 11.19375,22.5 11.296875,22.5 L12.703125,22.5 C12.80625,22.5 12.890625,22.415625 12.890625,22.3125 L12.890625,19.4484375 C16.321875,19.0429688 19.0429688,16.321875 19.4484375,12.890625 L22.3125,12.890625 C22.415625,12.890625 22.5,12.80625 22.5,12.703125 L22.5,11.296875 C22.5,11.19375 22.415625,11.109375 22.3125,11.109375 Z M12,17.71875 C8.840625,17.71875 6.28125,15.159375 6.28125,12 C6.28125,8.840625 8.840625,6.28125 12,6.28125 C15.159375,6.28125 17.71875,8.840625 17.71875,12 C17.71875,15.159375 15.159375,17.71875 12,17.71875 Z M12,9.1875 C11.2476562,9.1875 10.5445312,9.478125 10.0125,10.0125 C9.48046875,10.5445312 9.1875,11.2476562 9.1875,12 C9.1875,12.7523438 9.48046875,13.4554688 10.0125,13.9875 C10.5445312,14.5171875 11.25,14.8125 12,14.8125 C12.75,14.8125 13.4554688,14.5195312 13.9875,13.9875 C14.5171875,13.4554688 14.8125,12.75 14.8125,12 C14.8125,11.25 14.5195312,10.5445312 13.9875,10.0125 C13.4554688,9.478125 12.7523438,9.1875 12,9.1875 Z",
    id: "Shape",
    fill: "#205527"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAim);
export default __webpack_public_path__ + "static/media/aim.f0ad2ef133f893ebe294ef5a475e9847.svg";
export { ForwardRef as ReactComponent };